import Cookies from 'js-cookie';

export const updateCookie = (loginInfo) => {
    const map = Cookies.get('X-TOKEN') ? JSON.parse(Cookies.get('X-TOKEN')) : {};

    map[loginInfo.domain] = {
        access_key: loginInfo.access_key,
        secret_key: loginInfo.secret_key,
        timestamp: loginInfo.timestamp
    };

    Cookies.set('X-TOKEN', JSON.stringify(map), {
        expires: 10,
        path: '/',
        domain: '.grtcloud.net'
    });
};
export const getCookie = (domain) => {
    const map = Cookies.get('X-TOKEN') ? JSON.parse(Cookies.get('X-TOKEN')) : {};

    return map[domain || window.location.host];
};

export const clearCookie = (domain) => {
    const map = Cookies.get('X-TOKEN') ? JSON.parse(Cookies.get('X-TOKEN')) : {};

    map[domain] = null;

    Cookies.set('X-TOKEN', JSON.stringify(map), {
        expires: 10,
        path: '/',
        domain: '.grtcloud.net'
    });
    localStorage.removeItem('topMenu');
};
export const treeToList = (tree) => {
    let queen = [],
        out = [];
    queen = queen.concat(tree);
    while (queen.length) {
        let first = queen.shift();
        if (first.children) {
            // 下一层节点推入
            queen = queen.concat(first.children);
            delete first['children'];
        }
        out.push(first);
    }
    return out;
};
export const isMenuChecked = (curMenuItem, name) => {
    if (curMenuItem.name === name) {
        return true;
    }
    if (curMenuItem.children && curMenuItem.children.length > 0) {
        for (let i in curMenuItem.children) {
            let flag = isMenuChecked(curMenuItem.children[i]);
            if (flag) {
                return true;
            }
        }
    }

    return false;
};
export const isPC = function (req) {
    let userAgentInfo = req.headers['user-agent'],
     Agents = ['Android', 'iPhone', 'SymbianOS', 'Windows Phone', 'iPad', 'iPod'],
     flag = true;
    for (let v = 0; v < Agents.length; v++) {
        if (userAgentInfo.indexOf(Agents[v]) > 0) {
            flag = false;
            break;
        }
    }
    return flag;
};
